import axios from "axios";
import UrlAPI from '../../components/UrlAPI';

export default class BancoDeDadosNacionalApi {
  static enviaEmail(values, resolve, reset){
    return dispatch => {


      const promisses = [];
      const cnpj = values.cnpj.replace(/[^\d]/g, '');
      
      promisses.push(
        axios({
          method: 'POST',
          data: {
            "typeFile": "Atas",
            "cnpj": cnpj
          },
          url: `${UrlAPI.getUrl()}/public/upload-document`,
        })
          .then(res => {
            let options = {
              headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': values.fileAtas.type
              }
            };
            axios.put(res.data.url, values.fileAtas, options)
          })
      )

      promisses.push(
        axios({
          method: 'POST',
          data: {
            "typeFile": "Estatuto",
            "cnpj": cnpj
          },
          url: `${UrlAPI.getUrl()}/public/upload-document`,
        })
          .then(res => {
            let options = {
              headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': values.fileEstatuto.type
              }
            };
            axios.put(res.data.url, values.fileEstatuto, options)
          })
      )

      promisses.push(axios({
          method: 'POST',
          data: {
            "typeFile": "DocumentosResponsaveis",
            "cnpj": cnpj
          },
          url: `${UrlAPI.getUrl()}/public/upload-document`,
        })
          .then(res => {
            let options = {
              headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': values.fileDocumentosResponsaveis.type
              }
            };
            axios.put(res.data.url, values.fileDocumentosResponsaveis, options)
          })
      )

      promisses.push(axios({
        method: 'POST',
        data: {
          "typeFile": "Certificado",
          "cnpj": cnpj
        },
        url: `${UrlAPI.getUrl()}/public/upload-document`,
      })
        .then(res => {
          let options = {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': values.fileCertificado ? values.fileCertificado.type : ""
            }
          };
          axios.put(res.data.url, values.fileCertificado, options)
        })
    )

      axios.all(promisses)
        .then(() => {
          let message = `Nome da entidade: ${values.nomeEntidade} 
CNPJ: ${values.cnpj}

Cópia autenticada da Ata de Eleição e da Ata de posse da diretoria em exercício, devidamente registrada em cartório de Títulos e documentos, com mandato vigente: 
https://s3-sa-east-1.amazonaws.com/meiaentrada-documentos/${cnpj}/Atas 

Cópias autenticadas do Estatuto Social de entidade registrado em cartório: 
https://s3-sa-east-1.amazonaws.com/meiaentrada-documentos/${cnpj}/Estatuto 

Cópia autenticada dos documentos oficiais (RG ou CNH) e CPF dos responsáveis legais: 
https://s3-sa-east-1.amazonaws.com/meiaentrada-documentos/${cnpj}/DocumentosResponsaveis 

Cópia do certificado: 
https://s3-sa-east-1.amazonaws.com/meiaentrada-documentos/${cnpj}/Certificado 

Nome completo do representante: ${values.nomeRepresentante} 
Email do representante: ${values.emailRepresentante} 
Telefone de Contato: ${values.telefoneRepresentante} 
Nome do responsável pela operação: ${values.nomeOperacaoEntidade} 
E-mail do responsável pela operação: ${values.emailOperacaoEntidade}
Concorda em receber Comunicados: ${values.receberComunicados ? 'Sim, Concorda' : 'Não Concorda'}`;

          const body = {
            "from": "contato@meiaentrada.org.br",
            "replayto": values.emailOperacaoEntidade,
            "bcc": "",
            "to": "contato@meiaentrada.org.br",
            "subject": "Cadastro de Emissor",
            "body": message
          };

          const config = {
            headers: {
              'Content-Type': 'application/json'
            }
          };
          axios.post(`${UrlAPI.getUrl()}/public/email`, body, config)
          .then(() => {
            dispatch({type: 'MSGSUCCESS', msg: "Solicitação de cadastro enviada com sucesso! Aguarde, entraremos em contato"});
            window.grecaptcha.reset();
            dispatch(reset('formEmissor'));
          })
          .catch(() => {
            dispatch({type: 'MSGERROR', msg: 'Erro ao cadastrar emissor'});
          });
        //   setTimeout(function() {
        //   var validae={"certificate": `https://s3-sa-east-1.amazonaws.com/meiaentrada-documentos/${cnpj}/Certificado`};
        //   axios.post('https://api.meiaentrada.org.br/validate-certificate', validae).then((response)=>{
        //       if(response.data){
          
        //       }else{
        //         dispatch({type: 'MSGERROR', msg: 'Certificado Inválido'});
        //       }
        //   }).catch(() => {
        //     dispatch({type: 'MSGERROR', msg: 'Erro ao validar certificado'});
        //   });
        // }, 2500);
        })
        .catch((e) => {
          console.log("ERROR::", e)
          dispatch({type: 'MSGERROR', msg: 'Erro ao realizar upload de arquivo'});
        });

      resolve();
    }
  }
}


// WEBPACK FOOTER //
// ./src/logicas/BancoDeDadosNacional/BancoDeDadosNacionalApi.js